export default class Student {
  constructor(id, nameFirst, nameLast, address, city, state, zip, phone, cellPhone, emergencyPhone, email, dob, gender, startDate, rank, testNumber, beltSize, ITFnumber, lastTest, referral, active) {
    this.id = id != null ? id : "";
    this.nameFirst = nameFirst != null ? nameFirst : "";
    this.nameLast = nameLast != null ? nameLast : "";
    this.address = address != null ? address : "";
    this.city = city != null ? city : "";
    this.state = state != null ? state : "";
    this.zip = zip != null ? zip : "";
    this.phone = phone != null ? phone : "";
    this.cellPhone = cellPhone != null ? cellPhone : "";
    this.emergencyPhone = emergencyPhone != null ? emergencyPhone : "";
    this.email = email != null ? email : "";
    this.dob = dob != null ? dob : "";
    this.gender = gender != null ? gender : "";
    this.startDate = startDate != null ? startDate : "";
    this.rank = rank != null ? rank : "";
    this.testNumber = testNumber != null ? testNumber : "";
    this.beltSize = beltSize != null ? beltSize : "";
    this.ITFnumber = ITFnumber != null ? ITFnumber : "";
    this.lastTest = lastTest != null ? lastTest : "";
    this.referral = referral != null ? referral : "";
    this.active = active != null ? active : "";
  }
}